import Stickyfill from "stickyfilljs";

export function onClientEntry() {
  var elements = document.querySelectorAll(".sidebar-left");
  Stickyfill.add(elements);
}
